export const updateServiceCall = (rows) => {
    console.log(rows);
    var callFunction = new CallFunction('updateServiceCall', 'fad fa-phone-square-alt fa-3x');
    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = '';

    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }

    const param = [];
    rows.map(function (el, index) {
        param.push(el.CallID);
    });

    callFunction.showModal('Modification du statut de facturation');
    callFunction.modalBody.innerHTML = '<select class="form-control" id="newFacturation">' +
        '<option value="A_FACTURER">A facturer</option>' +
        '<option value="EN_ATTENTE_VALIDATION">En attente de validation</option>' +
        '<option value="FACTU?">Facturation ?</option>' +
        '<option value="FACTU_OK">Facturation OK</option>' +
        '<option value="PAS_DE_FACTU">Pas de facturation à faire</option>' +
        '<option value="A_REFACTURER_EN_INTERNE">A refacturer en interne</option>' +
        '<option value="REFACTU_INTERNE_OK">Refacturation interne OK</option>' +
        '<option value="">Vider le champ</option>' +
        '</select><br />' +
        '<div class="progress mb-2 d-none" id="updateSCProgressBar">' +
        '<div class="progress-bar bg-success" role="progressbar" style="width: 0%;" aria-valuenow="0" ' +
        'aria-valuemin="0" aria-valuemax="100" id="updateSCProgressBarValue">0%</div>' +
        '</div>' +
        '<a href="javascript:launchUpdateServiceCall([' + param.join(',') + '])" class="btn btn-success btn-block" id="updateSCButton">Valider la modification</a>';
    //$('#printInvoiceOnSiteBySelectionTextLoading').html('Modification en cours...');
    //$('#printInvoiceOnSiteBySelection').modal('show');
    //$('#printInvoiceOnSiteBySelectionHeader').removeClass('d-none');
}

export const launchUpdateServiceCall = (rows) => {
    $('#updateSCButton').addClass('d-none');
    $('#updateSCProgressBar').removeClass('d-none');

    launchOneUpdateServiceCall(rows,0);
}

export const launchOneUpdateServiceCall = (rows,index) => {
    const params = {
        'callId': rows[index],
        'newFacturation': $('#newFacturation').val()
    }

    $.post(urls.updateOneServiceCall,params, function(rep){
        const newIndex = index + 1;
        //callFunction.modalBody.innerHTML = newIndex + ' / ' + listDocEntry.length;
        const avancement = Math.round((newIndex / rows.length) * 100);
        $('#updateSCProgressBarValue').attr('aria-valuenow',avancement.toString());
        $('#updateSCProgressBarValue')[0].style.width = avancement + '%';
        $('#updateSCProgressBarValue').html(avancement + '%');

        if(newIndex<rows.length){
            launchOneUpdateServiceCall(rows,newIndex);
        } else {
            window.location.reload();
        }
    })
}



// WEBPACK FOOTER //
// ./assets/js/display_service_call.js